import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { useSelector } from "react-redux";
import isObjectEmpty from "../../helper/emptyObj";
Modal.setAppElement("#root");
const LocationModal = (props) => {
  const global = useSelector((state) => state.global);
  const searchData = useSelector((state) => state.searchData);
  const [modalIsOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (props.toggleModal) {
      openModal();
    }
  }, [props.toggleModal]);

  useEffect(() => {
    if (isObjectEmpty(searchData.filters) && modalIsOpen) {
      closeModal();
    }
  }, [searchData]);

  const openModal = () => {
    setIsOpen(true);
    props.callback();
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <div>
      <Modal
        portalClassName={"modal-app modal-app--simple"}
        overlayClassName={"modal-app__overlay"}
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        className="modal-app__wrapper"
        contentLabel="location modal"
      >
        <div className="modal-app__header">
          <h2 className="modal-app__title">
            {global.localization.locationModalTitle}
          </h2>
          <button
            className="modal-app__close"
            aria-label="close"
            onClick={closeModal}
          >
            <div className="icon">
              <img src="/assets/images/close.svg" alt="icon close" />
            </div>
          </button>
        </div>
        <div className="modal-app__cont">
          <div className="text">
            <p>{global.localization.locationModalText}</p>
          </div>
          <div className="button-row button-row--center">
            <div className="button-row__list">
              <button
                type="button"
                className="button"
                onClick={() => {
                  closeModal();
                }}
              >
                {global.localization.locationModalButton}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
export default LocationModal;
